<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModal"
    :showModal="showModal"
    @closeModal="showModal = false"
    :idProcesso="idProcesso"
    :tipo="tipoProcesso"
    :protocolo="protocolo"
    :numeroProcesso="numeroProcesso"
  )
  div.main.hidden-xs-only
    el-table(
      :data='processos',
      v-loading="loading",
      element-loading-text="Carregando..."
      @sort-change="changeOrder"
    )
      template(slot="empty") Não há registros.
      el-table-column(
        prop='numeroProcesso',
        label='Processo',
        width="auto"
      )
      el-table-column(
        prop='cpfCnpjInteressado',
        label='CPF/CNPJ do interessado',
        width="auto"
        align='center'
      )
      el-table-column(
        prop='nomeRazaoSocialInteressado',
        label='Nome/ Razão Social do interessado',
        width="auto"
      )
      el-table-column(
        prop='setor',
        label='Setor',
        :formatter="formatLabelSetor"
        width="auto"
      )
      el-table-column(
        prop='tipo.nome',
        label='Tipo de processo',
        width="auto"
      )
      el-table-column(
        label='Ações',
        width='120',
        align='center'
      )
        template(slot-scope='scope')
          el-dropdown(trigger="click")
            el-button(type='primary', size="small")
              | Ações
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item
                .flex(@click="abreModal(scope.row)")
                  i.fa.fa-eye
                  | &nbsp Visualizar processo
  div.pagination
     app-paginacao(
        :total="totalItems"
        :pagina="currentPage",
        @changePage="changePage",
        :tamanhoPagina="pageSize"
      )
</template>

<script>
import EnumFormatter from '@/utils/EnumFormatter'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto.vue'
import AppListagemRelatorio from './AppListagemRelatorio.vue'
import AppPaginacao from '@/components/AppPaginacao'
import setoresMA from '@/utils/ma/setor'

export default {

  components: {
    AppListagemRelatorio,
    AppModalVisualizarCompleto,
    AppPaginacao
  },

  data () {
    return {
      idProcesso: 0,
      numeroProcesso: '',
      tipoProcesso: '',
      protocolo: '',
      showModal: false
    }
  },

  props: {
    processos: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 15
    },
    totalItems: {
      type: Number,
      required: true
    },
    loading: {
      Type: Boolean,
      default: false
    },
    currentPage: {
      Type: Number,
      default: 1
    }
  },

  methods: {
    changePage (newPage) {
      return this.$emit('changePage', newPage)
    },
    getStatusFormatado (row) {
      return EnumFormatter.getStatusFormatado(row.status, row.setor)
    },
    getCpfCnpjInteressado (row) {
      if (row.cpfCnpjInteressado) {
        return row.cpfCnpjInteressado
      }
      return '-'
    },
    formatLabelSetor (prop, column, row) {
      if (process.env.ESTADO === 'ma') {
        if (row === setoresMA.setor.PROTOCOLO) {
          return setoresMA.nomesSetores.PROTOCOLO
        } else if (row === setoresMA.setor.JURIDICO) {
          return setoresMA.nomesSetores.JURIDICO
        } else if (row === setoresMA.setor.COMISSAO_ILHA) {
          return setoresMA.nomesSetores.COMISSAO_ILHA
        } else if (row === setoresMA.setor.PRESIDENCIA) {
          return setoresMA.nomesSetores.PRESIDENCIA
        } else if (row === setoresMA.setor.DF1) {
          return setoresMA.nomesSetores.DF1
        } else if (row === setoresMA.setor.DF3) {
          return setoresMA.nomesSetores.DF3
        }
      }
      if (prop.perfil === 'TECNICO_DE_CAMPO') {
        return `${row} - Técnico de campo`
      }
      if (prop.setor === 'GP' && prop.status.includes('ASSINATURA')) {
        return 'GP - Assinatura'
      }
      return row
    },
    isVerificaMunicipio (prop, column, row) {
      return row && row.length > 0 ? row[0].nome : '-'
    },

    isVerificaTecnico (row) {
      if (row.setor === 'CAF') return '-'
      return row?.usuario?.pessoa?.pessoaFisica?.nome || '-'
    },
    abreModal (processo) {
      this.idProcesso = processo.id
      this.numeroProcesso = processo.numeroProcesso
      this.tipoProcesso = processo.tipo.codigo
      this.protocolo = processo.numeroProtocolo
      this.showModal = true
    },

    changeOrder (column) {
      this.$emit('changeOrder', column)
    }
  }
}
</script>
<style lang="scss" scoped>

  .main {
    padding-top: 10px;
  }
  .pagination {
    text-align: center;
  }
  .align-center {
    text-align: center;
  }

  @media screen and (max-width: 1023px) {
    .hidden-sm {
      display: none;
    }
  }

  .row {
    border-bottom: 1px solid #ebeef5;
    font-weight: bold;
    font-size: 12px;
    span {
      margin-left: 5px;
      font-weight: normal;
    }
  }

  .row:first-child {
    border-top: 1px solid #ebeef5;
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppListagemProcessosAnalisados.vue